export default {
  bank: "Bank",
  winlose: "Win/Lose",
  balance: "Balance",
  win: "Win",
  lose: "Lose",
  tie: "Tie",
  history: "History",
  transfer_details: "Transfer Details",
  id: "ID",
  game: "Game",
  contactus: "Contact Us",
  join_now: "Join Now",
  manual_deposit: "Manual Deposit",

  aboutus: "About Us",
  attention: "Attention",
  amount_currency: "Amount ({currency} Min: {min} Max: {max})",
  all: "All",
  amount: "Amount",
  approved: "Approved",
  and: "and",
  atm_cash: "ATM/Cash Deposit",
  account_name: "Account Name",
  account_no: "Account No.",
  amount_min: "Minimum Amount",
  amount_max: "Maximum Amount",
  amount_not_min: "Amount does not reach minimum requirement",
  add_bank: "Add Bank",
  account_id: "Account ID",
  adjustment_details: "Adjustment Details",
  after_balance: "After Balance",
  android: "Android",
  atm: "ATM",
  acc_detail: "Account Details",
  about_us:{
    headline: "EPICWIN - THE #1 BRAND THAT PROTECTS YOUR MONEY",
    headlineContent_1: "Welcome to EpicWin, home of a Magical Gaming Experience that will forever change how you Win!",
    headlineContent_2: "We welcome ONE and ALL into our realm. Come and discover for yourself the MAGIC of what we have to offer.",
    box_one:{
      title: "EVERYHING UNDER ONE ROOF",
      content_1: "We run the show with our very own Operations, R&D, Design & Customer Service teams",
    },
    box_two:{
      title: "FAST PAYMENT",
      content_1: "1-MIN deposit & withdrawal with quick approval",
    },
    box_three:{
      title: "DELIVERING SATISFACTION",
      content_1: "We create world class games with the highest payouts that keep players coming back for more",
    },
    box_four:{
      title: "EPICWIN'S UNBEATABLE VALUE",
      content_1: "With no agents/middlemen, we can give more to players — higher payouts, extra game features & special members-only events",
    },
    swiperbox_one:{
      title: "#1 Slots Maker",
      highlight: "Over 120 games",
      detail: "premium & high payout slot games (and counting)",
      mobile: "Over 120 games"
    },
    swiperbox_two:{
      title: "SuperStar Slots Maker",
      detail: "Exciting movie collaborations & trending game titles",
    },
    swiperbox_three:{
      title: "EPICWIN MEMBERS",
      highlight: "480K REGISTERED MEMBERS",
      detail: "since March 18, 2020",
      mobile: "480K REGISTERED MEMBERS"
    },
    swiperbox_four:{
      title: "EPICWIN PAYS",
      highlight: "RM235 million turnovers",
      detail: "since March 18, 2020",
      mobile: "RM235 million turnovers"
    },
    swiperbox_five:{
      title: "LIVE STREAM PRIZES",
      highlight: "MYR60,000 in bonus rewards",
      detail: "Unbelievable giveaways with up to ",
      mobile: "MYR60,000"
    },
    swiperbox_six:{
      title: "EPIC MEDIA",
      detail: "#1 Entertainment Platform for Local Talents to Shine"
    },
    swiperbox_seven:{
      title: "W3 AR3 ON3",
      highlight: "MARCH 18, 2021",
      detail: "EpicWin Anniversary Milestone"
    },
    swiperbox_eight:{
      title: "EPIC COMMUNITY WANTS YOU",
      detail: "Join a welcoming & supportive player community that feels like family",
      mobile: "EPIC COMMUNITY"
    },
  },
  amount_receive: "Amount Received",
  active_player: "Total ACTIVE PLAYERS",
  affiliate_code: "Affiliate Code",
  admin: "Admin",
  admin_open: "If you have problem receiving TAC code, kindly contact us via Live Chat",
  affiliateUI: {
    title: "Affiliate Program",
    title1: "WHY JOIN US",
    detail: "Cashback up to 50%",
    detail1: "Lifetime earning",
    detail2: "Guarantee payment",
    button: "Join us & earn your cashback now!",
    step:{
      title: "How it works",
      detail: "The earning formula is simple. We provide you a unique tracking link to promote and your work is done.",
      step1: "Signup",
      step2: "Start promote with tracking link",
      step3: "Get unlimited cashback"
    },
    cashback:{
      title: "Cashback Structure",
      detail: "Cashback is based on total win lose which is Net Gaming Revenue (NGR) that generated from player who sign up under your tracking link",
      one: "NGR ≤ RM 20,000",
      two: "NGR  RM 20,001 - RM 40,000",
      three: "NGR  RM 40,001 - RM 60,000",
      four: "NGR ≥ RM 60,001",
      button: "Join us & earn your cashback now!"
    }
  },
  artist:{
    title: "EPIC Celebrity",
    mainintro1: "Epicwin Is Excited To Introduce Danny Chan",
    maindesc1: "The <strong>HONG KONG SUPERSTAR</strong> who is the 2020 Epicwin Brand SuperStar",
    artist_content1: "<strong>Danny Chan</strong> is a Hong Kong actor known for his resemblance to Bruce Lee, and his roles in Ip Man and Kung Fu Hustle!",
    watch_button1: "Watch Danny Chan's Video",
    mainintro2: "In Addition, We Would Like To Introduce3 Malaysian Epic Celebrities",
    maindesc2: "Malaysia’s Famous Youtuber 3P, Malaysia's Drift Queen Leona Chin and World's Top DJ RachelB!",
    artist_content2: "<strong>Rachel B's</strong> trademark energetic performance is loved by many as one of the Top DJs in Malaysia!",
    watch_button2: "Watch Rachel B's Video",
    artist_content3: "If you love YouTube, you're probably familiar with their faces - made famous by their creative and funny experimental video content!",
    watch_button3: "Watch ThreeeP's Video",
    artist_content4: "<strong>Leona Chin</strong> is the ultimate girl-next-door spiced with spunk, speed and thrill - know for being Malaysia's most inspiring female motorsport athlete award.",
    watch_button4: "Watch Leona Chin Video",
  },
  attachment: "Attachment",

  bank_accname: "Account Holder",
  bank_accno: "Account Number",
  bank_name: "Bank Name",
  bank_detail: "Bank Details",
  bet_history: "Bet History",
  bank_account: "Bank Account",
  better_luck: "Better luck next time!",
  birthday: "Birthday",
  bonus_details: "Bonus Details",
  before_balance: "Before Balance",
  bonus_value: "Bonus Value",
  bonus: "Bonus",
  brand: {
    vision: "BRAND VISION",
    vision_desc: "To create a community of winners with the biggest winnings",
    purpose: "BRAND PURPOSE",
    purpose_desc: "A trusted direct-deal slots maker brand with guaranteed payments"
  },
  back: "back",
  bonus_welcome: "Welcome Bonus",
  bonus_referral: "Referral Bonus",

  cdm: "CDM",
  counter: "COUNTER",
  cancel: "Cancel",
  change_password: "Change Password",
  confirm_password: "Confirm Password",
  close: "Close",
  claim: "Claim",
  claim_now: "claim now",
  current_balance: "Current Balance",
  cash_deposit: "Cash Deposit",
  contact_for_bank: "Contact EpicWin Livechat",
  congratulations: "Congratulations!",
  contact_number: "Contact Number",
  claim_rewards: "Claim Rewards",
  cash_value: "Cash Value",
  customer_review: "EPIC's REVIEWS",
  claim_offer: "Claim my offer!",
  custom_description: {
    free_spin: "RM50-RM99 + 1 Jackpot Ticket",
    free_spin2: "RM100-RM199 + 3 Jackpot Tickets",
    free_spin3: "RM200-RM499 + 7 Jackpot Tickets",
    free_spin4: "RM500-RM999 + 10 Jackpot Tickets",
    free_spin5: "≥RM1000 + 13 Jackpot Tickets",
    free_spin6: "RM5000-RM9999 + 25 Premium Free Spins",
    free_spin7: "≥RM10000 + 50 Premium Free Spins",
    free_spin8: "≥RM10000 + 100 Premium Free Spins and 14 Jackpot Ticket",
    get_freespin: "You get {amount} Free Spins",
    get_premiumspin: "You get {amount} Premium Free Spins",
    get_freespin_ticket: "You get {amount} Free Spins and {t_amount} Lucky Draw Ticket",
    get_premiumspin_ticket: "You get {amount} Premium Free Spins and {t_amount} Lucky Draw Ticket",
    get_jackpot_ticket: "You get {amount} Jackpot Tickets",
    get_euroticket: "You will get {amount} Euro Ticket",
    comment_placeholder: "leave your comments here",
    review_header: "Refer a friend to get a reward ",
    refer_info: "Earn <strong> 8x Free Spins</strong> for every RM30 Referred Friend's non promo Deposit",
    review_text: "Your friend's mobile number:",
    review_complete_header: "Thanks for spreading Good Vibes!",
    review_complete_text: "We'll Use it to improve the product.",
    home_title: "GUARANTEED 1-MIN",
    home_description: "#1 Fastest Withdrawal by Slots Maker",
    home_title2: "RAPID JACKPOT",
    home_description2: "We invented the fastest jackpot model & built it into Epic platform",
    home_title3: "SUPERSTAR SLOTS",
    home_description3: "We create exclusive games featuring: DC, Marvel, Disney and 20th Century Fox",
    home_title4: "NO AGENTS",
    home_description4: "We are a direct brand with no middlemen"
  },
  count: "Count",
  click_here: "Click Here",
  change: "Change",
  change_content:{
    mobile_title: "CHANGE TO WIN, CHANGE TO EPIC",
    title: "WHY SHOULD YOU CHANGE TO EPICWIN?",
    description: "EpicWin is a passionate Superstar Slots Maker, collaborating with the movie industry's biggest names such as Disney, Marvel & DC Comics. Offering the biggest online jackpot in Malaysia, EpicWin is the 1st direct-deal slots maker with NO AGENTS. Enjoy the fastest 1-MIN payments with EpicWin!",
    check_story: "CHECK OUT THE STORY",
    step: "STEP",
    step1_title: "Change to EpicWin",
    step1_description: "Switch from another brand",
    step1_description1: "to EpicWin",
    step2_title: "Record A Video",
    step2_description: "Record a video of yourself explaining",
    step2_description1: "why you switched over to EpicWin",
    step3_title: "Get Your Reward",
    step3_description: "Post your video on Facebook,",
    step3_description1: "submit the URL and win cool rewards!",
    video_title: "Change to Epic, Get Your Reward",
    small_label: "Facebook Video URL",
    placeholder: "Enter Your Facebook Video URL",
    tnc1: "Campaign Period: 1st Dec 2020 until 31st January 2021.",
    tnc2: "Follow the steps above and submit your video's URL to participate.",
    tnc3: "EpicWin Free Spins will be issued within 24 hours, upon verification of the video URL.",
    tnc4: "Each participant is eligible to win only once.",
    mobile_desc: "EpicWin is a Superstar Slots Maker, collaborating with the movie industry's biggest names such as Disney, Marvel & DC Comics. ",
    mobile_desc1: "Biggest online jackpot in Malaysia!",
    mobile_desc2: "1st direct-deal slots maker with NO AGENTS. Enjoy the #1 Fastest 1-MIN payments with EpicWin!"
  },
  coupon: "Coupon",

  deposit: "Deposit",
  deposit_enter: "Please enter deposit amount",
  deposit_method: "Deposit Method",
  deposit_method_select: "Please select a deposit method",
  deposit_reminder: "I have read, understood and agree to all the stipulated ",
  deposit_reminder_two: " covering bonuses and/or withdrawal requirements",
  download: "Download",
  download_android: "Android Download",
  download_ios: "iOS Download",
  date: "Date",
  done: "Done",
  deposit_now: "Deposit Now",
  description: "Description",
  download_1: "Join Now & Be a part of EPIC Family",
  download_2: "Your EPIC journey starts here!",
  deposit_tnc: "Deposit - Free Jackpot Tickets",
  developer_response: "Developer Response",
  daily_update: "Daily Update",
  downloadgame: "Download Game",
  duitnow:{
    desc1: "Minimum Deposit: ",
    desc1_1: "RM30",
    desc2: "Save receipt of transfer",
    desc3: "Notify LiveChat to receive credits.",
    desc4: "Enjoy playing our games!"
  },
  dailycheckin: "Daily Check In",
  deposit_topten: "Top 10 Deposit Count",
  demoplay:"Demo Play",
  deposit_page:{
    reminder1: "Balance must be below RM1 before deposit, or previous bonus rules will apply",
    reminder2: "Don’t use saved QR codes. Please use only the latest displayed QR code"
  },

  email: "Email",
  enter_bank_accname: "Please enter bank account holder name",
  enter_bank_accno: "Please enter bank account number",
  eta: "ETA",
  epic_production: "EPIC Production",
  expiry_date: "Expiry Date",

  female: "Female",
  failed: "Failed",
  forgot_password: "Forgot Password?",
  faq: "FAQ",
  footer: {
    title: "Calling all VIPs: the high rollers and just-for-fun-guys; the feet-up-unwinders and the buzz-seekers. For anyone who seek for TRUSTEDonline casino, EpicWin is here to show you the way.",
    description: "Welcome to EpicWin, home of the trendiest online slot games in Malaysia, offering players free play, free credit claim upon signup (just register to claim free credit), bonus giveaways, and of course, access to the best Malaysia online slot games that you won't find anywhere else.",
    description1: "But wait, before you start winning big, don't forget your \"claim free credit link\", which is your entitlement as a new EpicWin player that lets you kickstart your journey at this one-of-a-kind free credit casino, home to only the best free credit slot games. Register to claim free credit for your winning journey today!",
    description2: "Register to claim free credit on EpicWin and play the best Malaysia online slot games. Practice winning with EpicWin, Malaysia's best online casino with free credit, no deposit!",
    description3: "EpicWin is the top online slot Malaysia casino offering cool perks such as game slot free credit. It's a dream come true — sign up for free, claim free credit, and start your EPIC winning journey!",
  },
  for_android: "For Android",
  for_ios: "For iOS",
  find_out: "Find Out More",
  file_choose: "Choose File",
  file_upload: "Upload File",
  file_requirement: "File size cannot exceed 1mb and must be in png, jpg or jpeg format",
  full_name: "Full Name",
  fill_stars: "Kindly give your ratings before proceed",
  full_phone: "Phone Number (手机号码, Nombor Telefon)",
  full_referral: "Referral Code (邀友代码, Kod Pengajakan)",
  fish:"Fishing",

  gender: "Gender",
  game_play: "Game Play",
  game: "Game",

  hi: "Hi, ",
  has_won: "Has achieved",
  has_won_rate: " Winning Rate",
  has_withdraw: "Has withdrawn",
  has_deposit: "Has deposited",
  homepage: {
    header1: "ORIGINAL NOVOMATIC SLOTS",
    desc1: "Enjoy the best slots from the market leader!",
    header2: "LEADERBOARDS",
    desc2: "Play against your friends in multiple slot-themed leaderboards and races!",
    header3: "TOP BONUSES!",
    desc3: "Enjoy loads of bonuses and promotions!",
    header4: "VIP CLUB & LOYALTY PROGRAMME",
    desc4: "Let’s roll out the red carpet! As a VIP you can enjoy a host of benefits."
  },
  hourly_update: "Hourly Update",
  hot_movie: "HOT Movies",

  ios: "iOS",

  jackpot: "Jackpot",

  leaderboard_title: "TOP 15 PLAYERS WITH THE MOST MAGIC SPINS",
  login: "Login",
  logout: "Logout",
  login_now: "Login Now",
  lucky_spin: "lucky spin to win up to MYR{value}",
  latest_transactions: "Latest Transactions",
  lucky_wheel: "Lucky Wheel",
  loyalty_points: "loyalty points",
  last_4_digits: "Last 4 Digit of Phone Number",
  last_login: "Last Login",
  lang_en: "English",
  lang_zh: "Chinese",
  lang_my: "Malay",
  luckydraw_announcement: "You Will Earn Lucky Draw Tickets Upon Successful Deposit<br>Stay Tuned For Live Lucky Draw<br>19 April 2021, 7.30pm",
  language:{
    en: 'en',
    zh: 'zh-cn',
    my: 'ms'
  },
  later: "later",
  leaderboard: "Leaderboard",
  live:"Live",
  livecasino:"Live Casino",
  live_trans: "Live Transaction",
  lottery: "Lottery",

  male: "Male",
  mobile: "Mobile",
  minigames: "Mini Games",
  method: "Method",
  min: "Min.",
  min_amount: "Min Amount",
  monthly_update: "Monthly Update",
  movies: "Movies",
  movie_watch: "Watch Now",
  marquee:{
    notice: "Reminder:",
    announcement: "If unable to access {url}, please use <b style='color:#FFC000'>www.epicwin.asia</b> for uninterrupted gameplay! 💰100% GUARANTEED CUCI !"
  },
  more_info: "More Info",
  minigame:"Minigame",

  name: "Name",
  next: "next",
  new_password: "New Password",
  no_account_yet: "No Account Yet?",
  no_win: "You did not win anything this time around :(",
  nickname: "Nickname",
  next_update_time: "Next Update Time",
  no_bonus_found: "No bonus details found",
  no_adjustment_found: "No adjustment details found",
  no_new_gifts: "No new gifts",
  no: "No.",
  no_contact: "No contact available!",
  no_new_message: "No new message",
  newsletter: "I want to know about offers & promotion via email, text or post",
  news: "News",

  offical_team: "Official Team",
  online: "ONLINE",
  online_banking: "Online Banking",
  online_banking_set: "Online Banking ({bank})",
  option: "Option {0}",
  optional: "Optional",
  old_password: "Old Password",
  ok: "Ok",
  current_password: "Current Password",
  operator_bank_list: "Operator Bank List",
  promotion_selected: "Promotion selected",

  pending: "Pending",
  play_now: "Play Now",
  partner: "New Partner",
  partner_short: "Partner",
  partner_title: "EpicWin Exclusive Partners:",
  password: "Password",
  password_signup: "Password",
  phone_number: "Phone Number",
  promotion: "Promotion",
  promotions: "Promotions",
  promotion_select: "Please Select Promotion / No Promotion",
  profile: "Profile",
  privacy_policy: "Privacy Policy",
  privacy_statement: "Privacy Statement",
  password_tips:"Create your own password. Password must be 6-20 characters and a combination of number(s) and letter(s).",
  phone_tips: "Valid phone number ONLY eg: 0109471427, no spacing",
  problem_contact:"If you have problem receiving a code, kindly contact us via Live Chat.",
  reset_tips: "Please enter last 4 digits of your phone number",
  prev: "Prev",
  please_select: "Please Select",
  please_select_bank: "Please Select a Bank",
  please_select_payment: "Please select payment option",
  progress : "Progress",
  promotion_bonus: "Promotion Bonus",
  promotion_details: "Promotion Details",
  phone_no_reminder_recipient: "Please fill in recipient phone number",
  phone_recipient_same: "Recipient phone number cannot be the same as sender",
  promo_select: "Please Select Promotion",
  promo_none: "No Promotion",
  promo_text:{
    promo1: {
      title1: "Deposit:",
      details1: "MYR 30",
      title2: "Starting:",
      details2: "MYR 36",
      title3: "Withdraw:",
      details3: "MYR 108"
    },
    promo2: {
      title1: "Deposit:",
      details1: "MYR 10",
      title2: "Starting:",
      details2: "MYR 20",
      title3: "Withdraw:",
      details3: "MYR 50"
    },
    promo3: {
      title1: "Deposit:",
      details1: "MYR 10",
      title2: "Bonus:",
      details2: "MYR 12",
      title3: "Withdraw:",
      details3: "MYR 88"
    },
    promo4: {
      title1: "Deposit:",
      details1: "MYR 10",
      title2: "Starting:",
      details2: "MYR 11",
      title3: "Withdraw:",
      details3: "MYR 33"
    },
    promo5: {
      title1: "Deposit:",
      details1: "MYR 50",
      title2: "Starting:",
      details2: "MYR 62.5",
      title3: "Withdraw:",
      details3: "MYR 187.5"
    },
    promo6: {
      title1: "Attendance:",
      details1: "5 days",
      title2: "Accumulated Deposit:",
      details2: "MYR 150",
      title3: "Bonus:",
      details3: "MYR 10"
    },
    promo7: {
      title1: "Claim Frequency:",
      details1: "Once per day",
      title2: "Percentage Received:",
      details2: "10%",
      title3: "Withdrawal Requirement:",
      details3: "x 1"
    },
    promo8: {
      title1: "Deposit:",
      details1: "MYR 50",
      title2: "Starting:",
      details2: "MYR 57.5",
      title3: "Withdraw:",
      details3: "MYR 172.5"
    },
    promo9: {
      title1: "Bonus:",
      details1: "MYR 20",
      title2: "Withdrawal Requirement: ",
      details2: "Winover x3",
      title3: "Angpao: ",
      details3: "MYR 8"
    },
    promo10: {
      title1: "Bonus:",
      details1: "MYR 20",
      title2: "Accumulate Total",
      details2: "MYR 150"
    },
    promo11: {
      title1: "Deposit:",
      details1: "MYR 30",
      title2: "Bonus Amount",
      details2: "MYR 36",
      title3: "Withdrawal Requirement: ",
      details3: "Turnover x30",
    },
    promo12:{
      title1: "Deposit:",
      details1: "MYR 30",
      title2: "Bonus Amount",
      details2: "MYR 4.5",
      title3: "Withdrawal Requirement: ",
      details3: "Turnover x20",
    },
    promo13:{
      title1: "Deposit:",
      details1: "MYR 50",
      title2: "Bonus",
      details2: "MYR 12.5",
      title3: "Withdrawal Requirement: ",
      details3: "Turnover x20",
    },
    promo14:{
      title1: "Deposit:",
      details1: "MYR 1111",
      title2: "Bonus",
      details2: "MYR 33 + Win 1111",
    },
    promo15:{
      title1: "Bonus:",
      details1: "MYR 20 + 30",
      title2: "Accumulate Total",
      details2: "MYR 500",
    },
    promo16:{
      title1: "Angpao:",
      details1: "MYR 500",
      title2: "Winover",
      details2: "x10",
    },
    promo17:{
      title1: "Angpao:",
      details1: "MYR 33",
      title2: "Winover",
      details2: "x4",
    },
  },
  promo_detail:{
    general_tnc: "<p>GENERAL TERMS &amp; CONDITIONS</p><ul><li>Withdrawal is limited to 5 times per day.</li><li>EpicWin reserves all rights to terminate members' accounts in case of T&C violations without prior notice</li><li>Minimum withdrawal amount is RM10</li></ul>",
    general_tnc_casino:"<p>GENERAL TERMS &amp; CONDITIONS</p><ul><li>Burn <span class='text-danger'>WINNING BALANCE</span> and return <span class='text-danger'>DEPOSIT</span> if player break the T&C</li><li>Bonus and winning balance will expired after 30 days (Safety Purpose)</li><li><span class='text-danger'>Live Casino CANNOT play - Sports / Blackjack 21 / Texas Hold'em /（ Not Include Sport Book, Fishing , RNG table ,  Slot Game )</span></li></ul>",
    promo1:{
      title: "20% First Deposit Bonus (Daily on Weekdays)",
      table:{
        header1: "Deposit Amount",
        header2: "Bonus Amount",
        header3: "Starting Balance",
        header4: "Withdrawal Requirement",
        header5: "Min. Withdrawal",
        header6: "Max. Withdrawal(6x Deposit)",
        withdraw_req: "Winover x3"
      },
      tnc1: "Minimum deposit is RM30 and maximum bonus is RM30",
      tnc2: "Promotion is valid for Epicwin & MegaH5 and can be claimed once (1) per day on WEEKDAYS ONLY (Monday-Friday)",
      tnc3: "To withdraw, the winover requirement is 3x (deposit + bonus amount).",
      tnc4: "Any remaining credit balance after withdrawal will be removed from player's account",
    },
    promo2:{
      title: "Pin Top Up Welcome Bonus: 100% - Exclusive to EpicWin & Mega H5 Games",
      table:{
        header1: "Deposit Amount",
        header2: "Bonus Amount",
        header3: "Starting Balance",
        header4: "Withdrawal Requirement",
        header5: "Min. & Max. Withdrawal (5x Deposit)",
        withdraw_req: "Turnover x10"
      },
      tnc1: "Minimum deposit is RM10 and maximum bonus is RM50",
      tnc2: "Promotion is available for new member's first deposit on EpicWin and Mega H5 games only",
      tnc3: "To withdraw, the turnover requirement is 10x  (deposit + bonus amount)",
      tnc4: "Maximum withdrawal amount for this promotion can only be done once for a maximum of 5x of deposit amount. Any remaining credit balance after withdrawal will be removed from player's account",
      tnc5: "Any bets placed with other providers will result in voiding the winnings"
    },
    promo3:{
      title:"Welcome Bonus 120%",
      table0:{
        header1: "Welcome Bonus 120%",
        header2: "Minimum Deposit",
        header3: "Max Bonus Payout",
        header4: "Withdraw Requirement",
        header5: "Max Withdraw",
        row1: "1st Deposit"
      },
      table:{
        header1: "Deposit Amount",
        header2: "Bonus Amount",
        header3: "Starting Balance",
        header4: "Withdraw Requirement",
        header5: "Min Withdraw",
        withdraw_req: "Winover x4",
      },
      content1: "Example :",
      content2: "<span class='text-danger'>Deposit</span> 100 <span class='text-danger'>+ bonus</span> 120 <span class='text-danger'>= 220</span>",
      content3: "Minimum withdraw :",
      content4: "220 x 4 = 880",
      content5: "Maximum withdraw :",
      content6: "100 x 10 = 1000",
      content7: "Any remaining credit balance after withdrawal will be removed from player's account",
      tnc1: "The minimum deposit for this promotion is RM10, with a maximum bonus of RM120.",
      tnc2: "This promotion is available exclusively for new members making their first deposit on Epicwin.",
      tnc3: "The bonus applies to ALL SLOT GAMES",
      tnc4: "The MAX WITHDRAWAL is 10x the deposit amount.",
      tnc5: "This promotion is not applicable to Live Casino, Sportsbook, and Fishing games.",
      tnc6: "This promotion cannot be combined with other promotions unless otherwise specified.",
      tnc7: "Any remaining credit balance after a withdrawal will be removed from the player's account.",
      tnc8: "All bonuses and winnings will be cancelled if the member does not meet the turnover requirements within 30 days of the bonus being given.",
      tnc9: "This promotion can only be claimed once by new players as a welcome offer.",
      tnc10: "To claim this bonus, please contact our Live Chat support team."
    },
    promo4:{
      title:"Unlimited 10% Top Up Bonus - For ALL Players",
      table:{
        header1: "Deposit Amount",
        header2: "Bonus Amount",
        header3: "Starting Balance",
        header4: "Withdrawal Requirement",
        header5: "Min. Withdrawal",
        header6: "Max. Withdrawal",
        withdraw_req: "Winover x3"
      },
      tnc1: "Minimum deposit is RM10 and maximum bonus is RM50",
      tnc2: "Members can claim this promotion on EVERY deposit and it is valid for ALL slots.",
      tnc3: "To withdraw, the winover requirement is 3x (deposit + bonus amount)",
      tnc4: "Any remaining credit balance after withdrawal will be removed from player's account",
    },
    promo5:{
      title:"25% Weekend Bonus (Saturday & Sunday)",
      table:{
        header1: "Deposit Amount",
        header2: "Bonus Amount",
        header3: "Starting Balance",
        header4: "Withdrawal Requirement",
        header5: "Min. Withdrawal",
        header6: "Max. Withdrawal (8x Deposit)",
        withdraw_req: "Winover x3"
      },
      tnc1: "Minimum deposit is RM50 and maximum bonus is RM37.5",
      tnc2: "Promotion is valid for Epicwin & MegaH5 and members can claim this promotion ONCE on Saturday and Sunday",
      tnc3: "To withdraw, the winover requirement is 3x (deposit + bonus amount)",
      tnc4: "Any remaining credit balance after withdrawal will be removed from player's account",
    },
    promo6:{
      title:"DAILY CHECK IN BONUS",
      table:{
        header1: "Attendance",
        header2: "Accumulated Deposit",
        header3: "Bonus",
        header4: "Extra",
        attendance: "Accumulated any 5 days Within 30 Days",
        accumulated: "MYR {amount} and above"
      },
      tnc1: "To claim this bonus, player must make accumulated deposit of at least min RM150 on ANY 5 days within 30 days.",
      tnc2: "The final bonus will refer to the bonus table",
      tnc3: "Ensure your wallet balance is below RM0.50 to claim your daily check-in bonus. Otherwise, the balance will be tied to the claimed bonus T&C.",
      tnc4: "After collect this bonus, please contact our Live Chat to claim 10X Free Spin. ",
      tnc5: "Maximum withdrawal amount for this promotion can only be done once for a min & maximum of 5x (bonus amount)",
      tnc6: "This bonus cannot be claimed in conjunction with other deposit & promotions unless otherwise specified",
      tnc7: "Any remaining credit balance after withdrawal will be removed from player's account",
      tnc8: "Can Play All Slots",
    },
    promo7:{
      title:"FRIEND REFERRAL PROGRAM",
      table:{
        header1: "CashBack",
        header2: "Commision",
        header3: "Percentage Received",
        header4: "Withdrawal Requirement",
        details1: "Deposit of referred friend(s)",
        details2: "Turnover of downline",
        details3: "10%"
      },
      tnc1: "Earn 10% cashback or maximum up to RM20 for deposit made by new referred friend(s)",
      tnc2: "10% cashback bonus is valid when referred friend(s) deposit without promotion.",
      tnc3: "Claim requirement will be commission RM5 and above",
    },
    promo8:{
      title:"15% Weekend Bonus (Saturday & Sunday)",
      table:{
        header1: "Deposit Amount",
        header2: "Bonus Amount",
        header3: "Starting Balance",
        header4: "Withdrawal Requirement",
        header5: "Min. Withdrawal",
        header6: "Max. Withdrawal (8x Deposit)",
        withdraw_req: "Winover x3"
      },
      tnc1: "Minimum deposit is RM50 and maximum bonus is RM22.5",
      tnc2: "Promotion is valid for all slots EXCLUDE Epicwin & MegaH5 and members can claim this promotion ONCE on Saturday and Sunday",
      tnc3: "To withdraw, the winover requirement is 3x (deposit + bonus amount)",
      tnc4: "Any remaining credit balance after withdrawal will be removed from player's account",
    },
    promo9:{
      title: "520 Special",
      table:{
        header1: "Accumulated Deposit",
        header2: "Bonus",
        header3: "Withdrawal Requirement",
        header4: "Max. Withdrawal",
        header5: "Min. Withdrawal",
        header6: "Max. Withdrawal",
        detail1: "RM30 or above",
        withdraw_req: "Winover x3"
      },
      tnc1: "Event duration 7 - 20 May 2024",
      tnc2: "Depo total of MYR 520 & get a guaranteed MYR 20 Angpao",
      tnc3: "Extra 10 lucky players will get MYR 500, winner announcement on 21st May 2024 in <a href='https://web.telegram.org/k/#@epicwinspin' target='_blank'>EpicWin Telegram group</a> (claim date:  21 - 24 May 2024)",
      tnc4: "To claim Angpao, please kindly contact our LiveChat",
      tnc5: "Min Winover x3",
      tnc6: "Capped at MYR 500",
      tnc7: "Only for EpicWin & MegaH5 games",
    },
    promo10:{
      title: "Birthday Bonus",
      table:{
        header1: "Accumulated Deposit",
        header2: "Min. Claim",
        header3: "Max. Claim",
        header4: "Withdrawal Requirement",
        header5: "Max. Withdrawal",
        detail1: "15 or above",
        withdraw_req: "Winover x5"
      },
      tnc1: "To qualify for a RM20 bonus, player need to accumulate deposit of total RM150 on the day you register (Based on the register ID date ) . Once met this requirement, reach out to our live chat support to claim your bonus.",
      tnc1_1: "Example:",
      tnc1_2: "If your registration ID date is 2024-05-07, player need to accumulate deposit a total of RM150 on 7th of each month to be eligible to claim your RM20 bonus.",
      tnc2: "This bonus cannot be combined with other bonuses.",
      tnc3: "Epic Birthday: Please refer to the registration date under the ID profile, NOT the IC birthday date.",
      tnc4: "To claim this bonus, please contact our LiveChat.",
      tnc5: "Can claim once every month.",
      tnc6: "Can claim 12 times every year.",
      tnc7: "Only can play EpicWin and MegaH5.",
      tnc8: "Withdrawal requirement: Min & Max Win over x4 (MYR 80)."
    },
    promo11:{
      title: "Live Casino Welcome Bonus 120%",
      tnc1: "Players may claim the promotion only Once . To qualify, players have to make a minimum deposit of MYR 30, Max Bonus of RM 120",
      tnc2: {
        sub0: "The calculation for the deposit and bonus amount as below.",
        sub1: "Example:",
        sub2: "i. First Deposit = MYR 100",
        sub3: "ii. Bonus = First Deposit MYR 100 x 120% = MYR 120",
        sub4: "iii. Turnover requirement = (100 + 120) x 30 = MYR 6600"
      },
      tnc3: "Turnover requirement for the promotion is x30 times and Max can withdrawal Is ( Depo + Bonus ) x 10 ",
    },
    promo12:{
      title: "Live Casino WEEKDAYS 15% FIRST DEPOSIT BONUS",
      tnc1: "Players may claim the promotion once a day during weekdays. To qualify, players have to make a minimum deposit of MYR 30 , Max Bonus of RM 15.",
      tnc2: {
        sub0: "The calculation for the deposit and bonus amount as below.",
        sub1: "Example:",
        sub2: "i. First Deposit = MYR 100",
        sub3: "ii. Bonus = First Deposit MYR 100 x 15% = MYR 15",
        sub4: "iii. Turnover requirement = (100 + 15) x 20 = MYR 2300"
      },
      tnc3: "Turnover requirement for the promotion is x20 times and Max can withdrawal RM10,000.00",
    },
    promo13:{
      title: "Live Casino WEEKENDS 25% DEPOSIT BONUS",
      tnc1: "Players may claim the promotion once a day during weekends. To qualify, players have to make a minimum deposit of MYR 50 , Max Bonus of RM 37.50",
      tnc2: {
        sub0: "The calculation for the deposit and bonus amount as below.",
        sub1: "Example:",
        sub2: "i. First Deposit = MYR 100",
        sub3: "ii. Bonus = First Deposit MYR 100 x 25% = MYR 25",
        sub4: "iii. Turnover requirement = (100 + 25) x 20 = MYR 2,500"
      },
      tnc3: "Turnover requirement for the promotion is x20 times and Max can withdrawal RM10,000.00",
      tnc4: "To entitle this promotion, player able to click the promotion at the deposit page"
    },
    promo14:{
      title: "11.11 Epic Promo",
      tnc1: "Deposit a total of RM1,111 to instantly get RM33 during this promotion period. 11 Lucky Winners will be chosen to win RM1,111. Lucky winners will be announced on 12 November in EpicWin Telegram group. (Claim date: 12 - 15 November)",
      tnc2: "RM33 Guarantee Angpao Withdrawal Requirement:",
      tnc2_1: "- Deposit a total of RM1,111 and get RM33 instantly",
      tnc2_2: "- Winover x5",
      tnc2_3: "- Available to play on ALL slot games",
      tnc2_4: "- Maximum withdrawal x10 (RM330)",
      tnc3: "RM1,111 Lucky Draw Withdrawal Requirement:",
      tnc3_1: "- Deposit RM1,111, total of 11 players will be selected to win RM1,111 via lucky draw",
      tnc3_2: "- Winover x10",
      tnc3_3: "- Available to play on EpicWin & MEGAH5 games only",
      tnc3_4: "- Maximum withdrawal RM1,111",
      tnc4: "Bonus RM1888 Withdrawal Requirement : Turnover X7 , Max Cuci Bonus Amount RM1888, only can Play EpicWin & MegaH5 Games",
      tnc5: "This bonus cannot be combined with other bonuses",
      tnc6: "Min Winover x3",
      tnc7: "Applicable to ALL SLOT games only",
      tnc8: "To claim your bonus before starting the game, please contact our LiveChat"
    },
    promo15:{
      title: "RM50 Comeback Bonus",
      tnc1: "Depo an accumulate amount of MYR 500 & get MYR 20 (immediately) + RM30 (next month)",
      tnc2: "Min Winover x4",
      tnc3: "Max capped at MYR 500",
      tnc4: "Applicable to EpicWin games only",
      tnc5: "To claim your MYR 20 (immediate bonus) , please contact our LiveChat",
      tnc6: "To claim your MYR 30 (next month bonus) , can contact our our LiveChat on 1st of the month",
    },
    promo16:{
      title: "RM500 Olympic Tournament",
      tnc1: "Winners will be selected based on the Leaderboard for Deposit Count and Withdrawal Amount.",
      tnc2: "Event Period: 22nd Jul, 24th Jul, 26th Jul, 29th Jul, 31st Jul, 2nd Aug, 5th Aug, 7th Aug and 9th Aug",
      tnc3: "The 22nd Jul, 24th Jul, 7th Aug and 9th Aug are based on the Deposit Count Leaderboard.",
      tnc4: "The 26th Jul, 29th Jul, 31st Jul, 2nd Aug and 5th Aug are based on the Withdrawal Leaderboard.",
      tnc5: "The Top 3 winners of the Leaderboard can win an Epic Olympic Angpao:",
      tnc6: "Gold: MYR 500",
      tnc7: "Silver: MYR 200",
      tnc8: "Bronze: MYR 100",
      tnc9: "Winners will be announced at 6 PM on each event date.",
      tnc10: "Minimum Winover is x10(Max withdrawal bonus amount)",
      tnc11: "Applicable to EpicWin and MegaH5 slot games.",
      tnc12: "Livechat Claim"
    },
    promo17:{
      title: "MYR 33 Angpao",
      tnc1: "Depo a total of MYR 660 & get a guaranteed MYR 33 Angpao during the 33rd Olympics promotion period",
      tnc2: "Extra 10 lucky players will get MYR 660. Winner announcement on 8 Aug 2024 in the EpicWin Telegram group. (Claim Date: 8 - 12 Aug 2024)",
      tnc3: "Bonus MYR 33 Withdrawal Requirement : Winover X4 , Max cuci bonus amount X10 (MYR 330)",
      tnc4: "Only can play EpicWin & MegaH5 Games"
    },
    cny:{
      title: "CNY Deposit RM 2,888 & Win RM 2,888 Angpao",
      tnc1: "Deposit RM 2,888 during CNY (10 - 24 Feb 2024) to win up to RM 2,888 Angpao.",
      tnc2: "Qualified players receive a RM 88 CNY Angpao.",
      tnc3: "8 lucky players can win a RM 2,888 Epic Angpao from 25 - 28 Feb 2024.",
      tnc4: "Contact LiveChat to claim your Angpao.",
      tnc5: "Turnover requirement: x3.",
      tnc6: "Max withdrawal: x10, capped at RM 2,888.",
      tnc7: "Exclusive for EpicWin & MegaH5 games."
    },
    tnc: "TERMS AND CONDITIONS"
  },
  
  payment_option: "Payment Option",
  payment_list: "Accepted Payments",
  poker:"Poker",

  ref_num_enter: "Please enter reference number",
  register: "Register",
  register_now: "Register Now",
  responsible_gambling: "Responsible Gambling",
  responsible_gaming: "Responsible Gaming",
  rebate: "Rebate",
  rejected: "Rejected",
  result: "RESULT",
  reward: "Reward",
  rewards: "Rewards",
  referral: "Referral",
  referral_desc: {
    one : "Refer & earn cashback up to ",
    two: "RM20 ",
    three: "for every new Referred Friend's non promo deposit",
  },
  referral_prefix: "Refer & earn cashback up to RM20 for every new Referred Friend's non promo deposit! Link: ",
  referral_code: "Referral Code",
  resend: "Resend",
  request_again: "Request TAC",
  reference_number: "Reference Number",
  reference_number_tooltips: "Please enter reference number",
  remarks: "Remarks",
  real_time: "Real Time",
  recipient_id: "Recipient ID",
  review: "Review | review",
  review_title: "How was your experience?",
  registered_player: "Total REGISTERED PLAYERS",
  royalty_level:{
    1: 'Bronze',
    2: 'Silver',
    3: 'Gold',
    4: 'Platinum',
    5: 'Diamond'
  },
  register_title: "Register Now",
  reloadpincode: "Reload Pin Code",
  referral_rebate: "Referral Rebate",
  register_date: "Registration Date",
  reset_password: "Reset Password",
  remember_me: "Remember me?",
  responsible: "Responsible Gaming",

  save: "save",
  send: "Send",
  social_responsibility: "social responsibility",
  status: "Status",
  slots:"Slots",
  slotgames: "Slots",
  slot_play: "Play",
  slot_games: "Slot Games",
  slot_games_mobile: "Mobile Slot Games",
  signup: "Sign Up",
  signupform: {
    first_line: "I’m over 18 years of age and I accept these ",
    account_exist: "Already have an account?",
    verification_number: "Verification Number",
    problem_assist: "If you have problem receiving a code, kindly contact us via Live Chat.",
    subscription_confirm: "I want to know about offers & promotions via email, text or post.",
    account_success_first: "Your account has been ",
    account_success_second: "successfully created",
    deposit_now: "Deposit Now"
  },
  submit: "Submit",
  select_bonus: "Select Bonus",
  spin_again: "SPIN AGAIN",
  success: "Success",
  share_invite_code: "Share your invitation code",
  share_facebook:"Share to Facebook",
  share_to_friend: "Share to a Friend",
  share_referral_reward: "Get MYR 10.00 for both and your friend",
  select_deposit: "Please select deposit method",
  survey: {
    1: "Game Experience",
    2: "Withdrawal Speed",
    3: "Customer Service",
    4: "Game Design",
    5: "Refer Friend"
  },
  single_highest: "Single Bet with Highest Payout",
  share_title: "Share to:",
  settings: "Settings",
  subject: "Subject",
  search:"Search",

  tac_tips: "Didn't receive your TAC code? Please contact <u>Live Chat</u> for available rewards!",
  tac_tips2: "Didn't receive TAC?",
  time: "Time",
  tutorials: "Tutorials",
  type: "Type",
  transfer: "Transfer",
  transfer_amount: "Transfer Amount",
  transaction_history: "Transaction History",
  transfer_history: "Transfer History",
  tnc: "T&C",
  tnc_full: "Terms and Conditions",
  tnc_accept_reminder: "Please tick the checkbox to agree with our terms and conditions",
  ticket_status: {
    "0": "Rejected",
    "1": "Approved"
  },
  tac_code : "TAC Code",
  tac_code_new: "New Tac Code has been sent to your phone number",
  topten_WITHDRAWAL: "withdrew",
  topten_DEPOSIT:"deposited",
  transaction: "Transaction",
  tutorial_deposit: "How to Deposit - In-App",
  tutorial_withdrawal: "How to Make Withdrawal - In App",
  tutorial_transfer: "How to Transfer - In App",
  tutorial_android: "How to Download - Android",
  tutorial_ios: "How to Download - IOS",
  transfer_fee: "Transfer Fee",
  transfer_fee_message: " RM0.20 per transaction",
  thankyou:{
    header: "Welcome to the Epic Family.",
    description: "Every member will receive a token of appreciation."
  },
  total_withdrawal: "MONTHLY NO. OF WITHDRAWAL",
  total_review: "MONTHLY NO. OF REVIEW",
  top_games: "TOP 10 POPULAR GAMES",
  topgames_period: "LAST 30 DAYS",
  tips: "Tips",
  top30: "Top 30 Deposited Players",

  username: "Username",
  uh_oh: "Uh-oh!",
  statement: "Statement",
  upload_file: "Upload File",
  upload_file_tooltips: "File size cannot exceed 1mb and must be in png, jpg or jpeg format",
  update: "update",
  update_email: "Update Email",
  update_email_success: "Email Update Successfully",
  unknown: "Unknown",

  verification_number: "SMS TAC Code",
  view_transaction_history: "view transaction history",
  view_transaction: "You can view transaction history up to 90 days.",
  verification_no_required: "TAC Code Required",
  phone_no_reminder: "Please enter last 4 digits of your phone number",
  videos: "Videos",
  video_link: "Video URL",

  welcome_to: "Welcome To",
  welcome_1: "The #1 Brand By Slots Maker.",
  welcome_2: "With all payments guaranteed",
  welcome_3: "Not just a brand, We're Slots Maker",
  withdrawal: "Withdrawal",
  withdraw_required: "Withdrawal amount required.",
  withdraw_greater_50: "Withdrawal amount must be greater than or equal to 50.",
  worth: "Worth",
  withdrawal_details: "Withdrawal Detail",
  withdrawal_details1: "The Numbers of Withdrawal: 5 times per day",
  withdrawal_details2: "Duration: 1min: RM10, 000",
  withdrawal_details3: "Duration: 3min: RM100, 000 & Above",
  withdrawal_speed: "WITHDRAWAL SPEED",
  withdrawal_epic: "EPIC WITHDRAWAL",
  withdrawal_topten: "TOP 10 WITHDRAWAL",
  winner_topten: "TOP 10 EPIC WINNERS",
  withdrawal_reminder: "Reminder: To avoid forfeiting your balance, please withdraw the full amount if you're taking any promotion",

  you_won: "You won the",
  you_have: "You have",
  withdraw_target_tips: "You need hit the target to withdraw",

  promo_display:{
    OTB: "Welcome Bonus",
    UB: "Daily Deposit Bonus",
    VIPB: "VIP Bonus",
    DB: "Daily Deposit Bonus"
  },

  //promotion dropdown
  OTB90: {
    title: "Welcome Bonus",
    coinvalue: "19000",
    cashvalue: "190",
    percentage: "90"
  },
  OTB100:{
    title: "Welcome Bonus",
    coinvalue: "60000",
    cashvalue: "600",
    percentage: "100"
  },
  OTB80:{
    title: "Welcome Bonus",
    coinvalue: "9000",
    cashvalue: "90",
    percentage: "80"
  },
  OTB100D18:{
    title: "Welcome Bonus",
    coinvalue: "3600",
    cashvalue: "36",
    percentage: "100"
  },
  UB10D100:{
    title: "Daily Deposit Bonus",
    coinvalue: "11000",
    cashvalue: "110",
    percentage: "10"
  },
  UB10D200:{
    title: "Daily Deposit Bonus",
    coinvalue: "22000",
    cashvalue: "220",
    percentage: "10",
  },
  UB10D30:{
    title: "Daily Deposit Bonus",
    coinvalue: "3300",
    cashvalue: "33",
    percentage: "10",
  },
  UB10D300:{
    title: "Daily Deposit Bonus",
    coinvalue: "33000",
    cashvalue: "330",
    percentage: "10",
  },
  UB10D50:{
    title: "Daily Deposit Bonus",
    coinvalue: "5500",
    cashvalue: "55",
    percentage: "10",
  },
  UB20D10:{
    title: "Daily Deposit Bonus",
    coinvalue: "1200",
    cashvalue: "12",
    percentage: "20",
  },
  UB20D30:{
    title: "Daily Deposit Bonus",
    coinvalue: "3600",
    cashvalue: "36",
    percentage: "20",
  },
  UB20D50:{
    title: "Daily Deposit Bonus",
    coinvalue: "6000",
    cashvalue: "60",
    percentage: "20",
  },
  UB25D100:{
    title: "Daily Deposit Bonus",
    coinvalue: "12500",
    cashvalue: "125",
    percentage: "25"
  },
  UB25D200: {
    title: "Daily Deposit Bonus",
    coinvalue: "25000",
    cashvalue: "250",
    percentage: "25"
  },
  UB25D300:{
    title: "Daily Deposit Bonus",
    coinvalue: "37500",
    cashvalue: "375",
    percentage: "25"
  },
  VIPB110D1000:{
    title: "VIP Bonus",
    coinvalue: "210000",
    cashvalue: "2100",
    percentage: "110"
  },
  VIPB110D3000:{
    title: "VIP Bonus",
    coinvalue: "630000",
    cashvalue: "6300",
    percentage: "110"
  },
  VIPB110D5000:{
    title: "VIP Bonus",
    coinvalue: "1050000",
    cashvalue: "10500",
    percentage: "110"
  },
  VIPB110D10000:{
    title: "VIP Bonus",
    coinvalue: "2100000",
    cashvalue: "21000",
    percentage: "110"
  },
  VIPB200D300:{
    title: "VIP BONUS",
    coinvalue: "50000",
    cashvalue: "500",
    percentage: "MYR 200"
  },
  DB20D10:{
    title: "Daily Deposit Bonus",
    coinvalue: "1200",
    cashvalue: "12",
    percentage: "20"
  },

  turnover_downline: "Downline Turnover",
  daily_rebate: "Daily Game Rebate",
  redeem_ticket: "Redeem Ticket",
  redeem: "redeem",
  turnover_amount: "Turnover Amount",
  no_record: "No Record Found",
  share: "Share",
  total_downline: "Total Downline",
  rebate_toclaim: "Claimable Rebate",
  rebate_total: "Total Rebate",
  provider: "Provider",
  turnover: "Turnover",
  inbox: "Inbox",
  item: "Item",
  sb_custom: "Sportsbook",
  platform: "Platform",
  adjustment: "Adjustment",
  referee: "Referee",
  game_name: "Game Name",
  referral_link: "Referral Link : ",
  trans_time: "Trans.Time",
  sportsbook: "Sportsbook",
  event: "Event",
  odds: "Odds",
  odd: "Odd",
  stake: "Stake",
  ref_no: "Ref No.",
  lost: "Lost",
  draw: "Draw",
  american_football: "American Football",
  soccer: "Soccer",
  basketball: "Basktetball",
  baseball: "Baseball",
  esports: "E-Sports",
  esports2: "E-Sports",
  tennis: "Tennis",
  even: "Even",
  over: "Over",
  under: "Under",
};
